//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from "vuex";

export default {
    props: {
        sendAllActionDetails: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            warnings: [],
            errors: {
                errorLabel: "",
                errorToDisplay: "",
                type: "",
                id: ""
            }
        };
    },
    computed: {
        ...mapGetters("diagrams", ["diagramPlugins", "diagramData", "getWarningsList", "getProcessWithError"]),
        ...mapGetters("apps", ["currentProcess"])
    },
    watch: {
        getWarningsList: {
            handler(newValue) {
                this.warnings = newValue || [];
                this.$emit("diagramWarnings", this.warnings);
            },
            immediate: true
        },
        "diagramData.content": {
            handler() {
                this.createErrorCard();
            }
        }

    },
    activated() {
        this.createErrorCard();
    },
    created() {
        this.$root.$on("showErrorCard", () => {
            this.createErrorCard();
        });
    },
    beforeDestroy() {
        this.$root.$off("showErrorCard");
    },
    methods: {
        createErrorCard() {
            if (this.getProcessWithError && this.getProcessWithError.id === this.currentProcess.id) {
                if (this.getProcessWithError.errorOnPublish) {
                    if (this.getProcessWithError.errorOnPublish.id) {
                        const { id, message, type, name } = this.getProcessWithError.errorOnPublish;
                        const tooltipNewMesage = message.includes(id) ? message.split(id) : message;
                        this.errors.id = id;
                        this.errors.type = type;
                        if (tooltipNewMesage) {
                            this.errors.errorLabel = name;
                            if (type === "START_BLOCKCHAIN_EVENT_PLUGIN") {
                                this.errors.errorToDisplay = this.errors.errorLabel && tooltipNewMesage.length
                                    ? this.$t("diagrams.components.setBlockchain.startFromBkActivity") + tooltipNewMesage[tooltipNewMesage.length - 1] : "";
                            } else if (type !== "PROCESS_PLUGIN") {
                                this.errors.errorToDisplay = this.errors.errorLabel && tooltipNewMesage.length
                                    ? this.errors.errorLabel + tooltipNewMesage[tooltipNewMesage.length - 1] : "";
                            } else if (this.errors.errorLabel) {
                                this.errors.errorToDisplay = tooltipNewMesage.length
                                    ? tooltipNewMesage[tooltipNewMesage.length - 1] : "";
                            } else {
                                this.errors.errorToDisplay = tooltipNewMesage;
                            }

                            if (this.errors.errorToDisplay === "Exclusive gateway") {
                                this.errors.errorToDisplay = this.$t("mainPage.exclusiveGatewayError");
                            }
                        }
                    } else {
                        this.errors.errorToDisplay = this.getProcessWithError.errorOnPublish;
                    }
                    this.$emit("diagramErrors", [this.errors]);
                } else {
                    this.errors.errorLabel = "";
                    this.errors.errorToDisplay = "";
                    this.errors.type = "";
                    this.errors.id = "";
                    this.$emit("diagramErrors", []);
                }
            } else {
                this.errors.errorLabel = "";
                this.errors.errorToDisplay = "";
                this.errors.type = "";
                this.errors.id = "";
                this.$emit("diagramErrors", []);
            }
        },
        jumpToElement({ type, id }) {
            if (id) {
                if (type === "CONNECTOR") {
                    this.$emit("selectCurrentConnector", this.sendAllActionDetails ? { type, id } : id);
                } else {
                    this.$emit("selectCurrentPlugin", this.sendAllActionDetails ? { type, id } : id);
                }
            }
        }
    }
};
